import store from "@/store/index.js";


export async function chat(model="", key, text) {

    console.log(key)
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${key}`);
    return new Promise((resolve, reject) => {

        const messageList = store.state.messageList;

        if(model){
            messageList.push({
                "role":"system",
                "content":model
            })
        }


        messageList.push({
            "role": "user",
            "content": text,
        })
        store.commit("setMessageList", messageList);



        fetch(`https://ark.cn-beijing.volces.com/api/v3/chat/completions`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                "model": "doubao-1-5-pro-32k-250115",
                "stream": false,
                "stream_options": {
                    "include_usage": true
                },
                "messages": messageList
            })
        })
            .then(res => res.json())
            .then((res) => {

                if (res?.error?.code == "AccountOverdueError") {
                    console.log("欠费")
                    reject("您的API余额欠费,请充值后使用")

                    return false;
                }

                if (res?.choices[0]?.message?.content) {
                    messageList.push({
                        "role": "assistant",
                        "content": res?.choices[0]?.message?.content
                    })
                    store.commit("setMessageList", messageList);

                    resolve(res?.choices[0]?.message?.content)
                } else {
                    console.log("您的API余额欠费,请充值后使用")

                    if (res?.error && res?.error.code == "AccountOverdueError") {
                        console.log("您的API余额欠费,请充值后使用")


                    }

                    resolve(false);
                }
            }).catch(() => {
                resolve(false);
            }
        )


    })


}
